import Icons from 'Icons';
import MyTextInput from 'components/MyTextInput/MyTextInput';
import React, { useEffect, useState } from 'react';
import coalesceClassNames from 'utils/coalesceClassNames';
import {
    CriteriaCompProps,
    DataTableCriteriaFieldBase,
    DataTableCriteriaPlugin,
} from '../DataTableCriteriaTypes';

export type SearchCriteriaFieldConfig = DataTableCriteriaFieldBase & {
    type: 'search';
    size?: 'small' | 'medium';
};

function SearchFilter({ field, onChange }: CriteriaCompProps<SearchCriteriaFieldConfig>) {
    const [value, setValue] = useState(field.config.defaultValue || '');

    const handleInput = (val: string) => {
        setValue(val);
        field.value = val;
        onChange?.(field);
    };

    useEffect(() => {
        setValue(field.value);
    }, [field.value]);

    return (
        <div
            className={coalesceClassNames(
                'DataTableCritiera__Field',
                'DataTableCritiera__Field--Search',
            )}
        >
            <MyTextInput
                // label={filter.label}
                value={value}
                handleInput={handleInput}
                LeftIcon={Icons.Search}
                showClearButton={true}
                size={field.config.size}
            />
        </div>
    );
}

const plugin: DataTableCriteriaPlugin<SearchCriteriaFieldConfig> = {
    Component: SearchFilter,
};
export default plugin;
